module.exports = __webpack_public_path__ + "static/media/cammino_santiago_4.981d7bc4.jpg";